import { useFormContext } from "@/app/components/formContext/formcontext";
import VehicleCardRural from "@/app/components/ServicesComponents/RuralCard";
import {
  CustomPaging,
  SampleNextArrow,
  SamplePrevArrow,
} from "@/app/components/swipersComponents";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { withServicesLayout } from "@/pages/_layoutService";

function Governo() {
  const { setOptions, setInputValue } = useFormContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-governo" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const cars = [
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Governo/governo_corolla.png",
      name: "COROLLA",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Governo/governo_corolla_cross.png",
      name: "COROLLA CROSS",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Governo/governo_rav4.png",
      name: "RAV4",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Governo/governo_hilux.png",
      name: "HILUX",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Governo/governo_sw4.png",
      name: "SW4",
      details: "",
      year: "2024/2024",
    },
  ];
  const models = cars.map(
    (m) => `${m.name} ${m.details == "" ? "" : "-"} ${m.details}`,
  );

  useEffect(() => {
    setOptions([...models]);
  }, []);
  return (
    <>
      <div className="w-full text-zinc-800 p-3">
        <div className="w-full  lg:h-40 mt-5 lg:p-3 ">
          <h1 className="text-[40px]  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            Governo
          </h1>
          <div className="w-16 border-b-2 ml-1 border-red-600 " />
        </div>
        <p className="mt-10">
          Órgãos do governo possuem condições especiais. Para consultá-las,
          solicite uma cotação ou vá até a Concessionária Toyota mais próxima.
        </p>
        {/*<h2 className="text-2xl py-5">Todos modelos disponíveis:</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-lg:hidden">
          {cars.map((vehicle, index) => (
            <VehicleCardRural
              key={"cardVehicle.governo" + index}
              imageSrc={vehicle.imageSrc}
              name={vehicle.name}
              details={vehicle.details}
              year={vehicle.year}
              onClick={() => setInputValue(models[index])}
            />
          ))}
        </div>*/}
        {/*<div className="flex flex-col gap-5 lg:hidden mb-20">
          <Slider {...settings}>
            {cars.map((vehicle, index) => (
              <VehicleCardRural
                key={"cardVehicle.governo.mbl" + index}
                imageSrc={vehicle.imageSrc}
                name={vehicle.name}
                details={vehicle.details}
                year={vehicle.year}
                onClick={() => setInputValue(models[index])}
              />
            ))}
          </Slider>
        </div>*/}
        <h2 className="text-2xl py-5">
          Quais documentos são necessários para inclusão do pedido?
        </h2>
        <p className="pb-5">
          - CNH em nome do Titular da Placa de Taxi;
          <br />
          - Alvará vigente expedido pela Prefeitura Municipal;
          <br />
          - Comprovação de endereço vinculado ao Município da Licença de TAXI;
          <br />
          - Isenção de IPI e ICMS (se houver) com validade igual ou superior ao
          prazo estabelecido pelo fabricante para o faturamento;
          <br />- Declaração ou Decreto Municipal que confirme o aceite do
          modelo ou cor do veículo a ser adquirido. (Alguns municípios
          estabelecem regras quanto ao modelo e cor, por isso, é importante a
          apresentação do documento a fim de evitar suspensão do emplacamento
          após a emissão da NF).
        </p>
      </div>
    </>
  );
}
export default withServicesLayout(Governo);
export { getServerSideProps } from "@/pages/_layoutService";
